
import { defineComponent } from 'vue'
import styleDescriptor from '@/modules/workspace/gisDocumentDesigner/GisDocumentDesignerDescriptor.json'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import Dropdown from 'primevue/dropdown'

export default defineComponent({
    components: { DataTable, Column, Dropdown },
    emits: ['joinsValidationChanged'],
    props: { documentDataProp: { type: Object as any, required: false } },
    computed: {
        joinsInvalid() {
            if ((this.documentDataProp.dsJoins.length == 0 && this.documentDataProp.datasetLabel != '') || this.joinsContainEmptyFields) {
                return true
            } else return false
        },
        joinsContainEmptyFields() {
            let value = false
            this.documentDataProp.dsJoins.forEach((field) => {
                if (!field.datasetColumn || !field.layerColumn) {
                    value = true
                } else value = false
            })
            return value
        }
    },
    data() {
        return {
            styleDescriptor,
            documentData: {} as any
        }
    },
    created() {
        this.documentData = this.documentDataProp
        this.$emit('joinsValidationChanged', 'joinsInvalid', this.joinsInvalid)
    },
    watch: {
        documentDataProp() {
            this.documentData = this.documentDataProp
        },
        joinsInvalid() {
            this.$emit('joinsValidationChanged', 'joinsInvalid', this.joinsInvalid)
        }
    },
    methods: {
        addJoinRow() {
            this.documentData.dsJoins.push({ datasetColumn: null, layerColumn: null })
        },
        deleteJoinRow(eventData) {
            this.documentData.dsJoins.splice(eventData.index, 1)
        }
    }
})
